import { PropertyDetailsLayout, useBrowserTitle } from '@acp/core-ui';
import React, { Suspense } from 'react';
import { useExperiment } from '@acp/feature/auth';
import { Experiment } from '@acp/shared';
import { AppError } from './app-error';

const CorporateDashboardPage = React.lazy(() => import('../features/corporate/page'));

export function Analytics() {
    useBrowserTitle('Corporate Dashboard');
    const { isLoading, hasExperiment } = useExperiment();
    const isPageEnabled = hasExperiment(Experiment.AgencyCompliancePortalAdvancedAnalytics);

    if (!isPageEnabled) {
        return <AppError />;
    }

    return (
        <Suspense fallback={<PropertyDetailsLayout.Skeleton />}>
            {/* eslint-disable-next-line no-nested-ternary */}
            {isLoading ? (
                <PropertyDetailsLayout.Skeleton />
            ) : (
                <CorporateDashboardPage />
            )}
        </Suspense>
    );
}
